module.exports = __webpack_public_path__ + "static/media/logo.d8fba5cc.svg";